export const tabs = {
  root: {
    borderColor: '{content.border.color}',
  },
  tab: {
    borderWidth: '0',
    activeColor: '{primary.color}',
  },
  tabpanel: {
    background: 'rgba(0, 0, 0, 0)',
    padding: '0',
  },
  tablist: {
    background: 'rgba(0, 0, 0, 0)',
  },
  colorScheme: {
    dark: {
      tab: {
        background: 'rgba(0, 0, 0, 0)',
        activeBackground: '{surface.0}',
      },
    },
  },
}
